import React, { useEffect, useRef } from "react";
import scrollIntoView from "dom-scroll-into-view";
import styles from "./groupPage.scss";
import StepHeader from "../StepHeader";
import GroupControls from "./GroupControls";
import StepFooter from "../StepFooter";
import NextButton from "../StepFooter/NextButton";
import FooterBackButton from "../StepFooter/BackButton";
import SaveAndContinueButton from "../StepFooter/SaveAndContinueButton";
import {
  scrollToTop,
  isSafari,
  isMobileScreen,
  getWindowWidth
} from "../../../services";
import { POST_AD_CONTAINER_ID } from "../../../constants";
import HelmetComponent from "../../../utils/HelmetHelper";
import { FormFieldConditions } from "../../../hooks/useFormFieldConditions";

const progressBarOffsetTop = 80;

interface GroupPageProps {
  controls: { description: string; groups: {}[]; name: string }[];
  form: any;
  goBack: () => void;
  match: { path: string; url: string; isExact: boolean; params: {} };
  handleSubmit: (event: any) => void;
  handleSaveAndExit?: () => void;
  headerTitle?: string;
  fullWidth?: boolean;
  isValidating?: boolean;
  setIsValidating?: (isValidating: boolean) => void;
  isUpdate?: boolean;
  fieldConditions?: FormFieldConditions;
}

const GroupPage = (props: GroupPageProps) => {
  const {
    controls,
    headerTitle,
    fullWidth,
    form,
    handleSubmit,
    handleSaveAndExit,
    match,
    goBack,
    isValidating,
    setIsValidating,
    isUpdate,
    fieldConditions
  } = props;

  const wrapperRef = useRef();
  const isMobile = isMobileScreen(getWindowWidth());

  useEffect(() => {
    const postAdContainer = document.getElementById(POST_AD_CONTAINER_ID);

    if (postAdContainer && isSafari() && isMobile) {
      // check is mobile here
      scrollIntoView(wrapperRef.current, postAdContainer, {
        offsetTop: progressBarOffsetTop
      });
    } else {
      setTimeout(() => {
        scrollToTop();
      });
    }
  }, []);


  return (
    <div ref={wrapperRef}>
      <HelmetComponent
        title={`${"Formular"} | ${"INDEX OGLASI"}`}
        index={false}
      />

      <StepHeader title={headerTitle} />
      <div className={styles.container}>
        <GroupControls
          isFullWidth={fullWidth}
          form={form}
          controls={controls}
          match={match}
          setIsValidating={setIsValidating}
          fieldConditions={fieldConditions}
        />
      </div>

      <StepFooter
        leftButton={<FooterBackButton onClick={goBack} />}
        rightButton={
          <div className={styles.footerActions}>
            {!isUpdate && handleSaveAndExit && (
              <SaveAndContinueButton
                onClick={handleSaveAndExit}
                disabled={isValidating}
              />
            )}
            <NextButton onClick={handleSubmit} isUpdate={isUpdate} isLoading={isValidating} />
          </div>
        }
      />
    </div>
  );
};

GroupPage.defaultProps = {
  fullWidth: false,
  isValidating: false
};

export default GroupPage;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/index.tsx